import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
let default_1 = class extends Vue {
  activated() {
    const {
      params,
      query
    } = this.$route;
    const {
      path
    } = params;
    this.$router.replace({
      path: '/' + path,
      query
    });
  }
  render() {
    // Avoid warning for missing template
  }
};
default_1 = __decorate([Component({
  name: 'Redirect'
})], default_1);
export default default_1;